export default "__VITE_ASSET__EebIfG7k__"